import React from "react";
import {Label} from "reactstrap";
import Select from "react-select";
import {ErrorMessage, useField} from "formik";
import {capitalizeFirst} from "../../common/general";

const SelectField = (props) => {
  const [field, meta, helpers] = useField(props.name);

  const selectOptionHandler = selectedOption => {
    helpers.setValue(selectedOption)
    if (props.onChange) {
      props.onChange(selectedOption)
    }
  }

  const onBlur = (e) => {
    helpers.setTouched(true)
    field.onBlur(e)
  }

  return (
    <React.Fragment>
      <Label htmlFor={field.name}>
        {capitalizeFirst(props.label)}
      </Label>
      <Select
        options={props.options}
        value={field.value}
        isMulti={props.isMulti}
        onChange={selectOptionHandler}
        onBlur={onBlur}
        className={(meta.error && meta.touched ? "is-invalid" : "")}
        isClearable={props.isClearable}
        styles={{
          control: (provided, state) => (meta.error && meta.touched ? {
            ...provided,
            borderColor: 'red',
            '&:hover': {
              borderColor: 'red',
            }
          } : provided)
        }}
      />
      <ErrorMessage name={field.name} component="div" className="invalid-feedback"/>
    </React.Fragment>
  )
}

export default SelectField